import { RelayClientTransport } from '~/modules/remote-mic/network/client/transport/relay-client-transport';
import { WEBSOCKETS_SERVER } from '~/modules/remote-mic/network/server/transport/web-socket-server';

export class WebSocketClientTransport extends RelayClientTransport {
  // The room is named in the `register-player` message rather than in the URL, so every room on
  // this relay dials the same address.
  protected getUrl = (_roomId: string) => WEBSOCKETS_SERVER;
}
